// Components==============
// =========================

export function useGraphDays(
    data: (GraphDataEntity | undefined)[],
    firstDay: number
) {
    const days: (
        | { day: number; dayNr: number; name: string; item: GraphDataEntity }
        | undefined
    )[][] = [];

    function dayExists(dayNr: number) {
        return (
            days.find((day) => day.find((d) => d?.day === dayNr)) !== undefined
        );
    }

    function formatDay({
        day,
        item,
        dayNr,
        name,
    }: {
        day: number;
        item: GraphDataEntity;
        dayNr: number;
        name: string;
    }) {
        const newItem = { day, dayNr, name, item };

        if (!dayExists(day)) return days.push([newItem]);

        const index = days
            .map((d, i) => (d[0]?.day === day ? i : undefined))
            .filter((exists) => exists || exists === 0)[0];

        if (index || index === 0) days[index].push(newItem);
    }

    data.forEach((item) => {
        if (!item?.updated_at) return;
        const day = new Date(item?.updated_at).getDay();

        if (day === 0)
            return formatDay({ day, item, dayNr: 7, name: 'Zondag' });
        if (day === 1)
            return formatDay({ day, item, dayNr: 1, name: 'Maandag' });
        if (day === 2)
            return formatDay({ day, item, dayNr: 2, name: 'Dinsdag' });
        if (day === 3)
            return formatDay({ day, item, dayNr: 3, name: 'Woensdag' });
        if (day === 4)
            return formatDay({ day, item, dayNr: 4, name: 'Donderdag' });
        if (day === 5)
            return formatDay({ day, item, dayNr: 5, name: 'Vrijdag' });
        if (day === 6)
            return formatDay({ day, item, dayNr: 6, name: 'Zaterdag' });
    });

    // @ts-ignore
    const sortedDays = days.sort((a, b) => b?.[0]?.dayNr! < a?.[0]?.dayNr!);

    const indexOfFirstDay = sortedDays
        .map((d, i) => (d[0]?.dayNr === firstDay ? i : NaN))
        .filter((exists) => exists || exists === 0)[0];

    const startOfWeek = sortedDays?.slice(indexOfFirstDay, sortedDays.length);
    const endOfWeek = sortedDays?.slice(0, indexOfFirstDay);

    return [...startOfWeek, ...endOfWeek];
}
